<script>
export default {
  name: 'CompanyLoadingIndicator',
  props: {
    label: {
      type: String,
      default: '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div
    class="flex items-center justify-center gap-2 text-sm text-muted"
    :class="compact ? 'py-3' : 'min-h-[8rem] py-8'"
    role="status"
    aria-live="polite"
  >
    <span
      class="h-6 w-6 shrink-0 animate-spin rounded-full border-2 border-line-strong border-t-woot-500 dark:border-t-woot-400"
      aria-hidden="true"
    />
    <span v-if="label">{{ label }}</span>
  </div>
</template>
